import * as Yup from 'yup';
import {TYPE} from './index';

export const AddReviewInterviewFormValidationSchema = Yup.object().shape({
  firm: Yup.object()
    .nullable()
    .required('Firm field is required'),

  rating: Yup.number()
    .nullable()
    .min(1, 'Rating is required')
    .required('Rating is required'),

  q1: Yup.object()
    .nullable()
    .test(
      'is-q1',
      'This field is required',
      value => value && value.month && value.year
    ),

  q2: Yup.object()
    .nullable()
    .when(['type'], (type, schema) => {
      if (type === TYPE.RECRUITER) {
        return schema;
      }
      return schema.required('This field is required');
    }),

  q3: Yup.object()
    .nullable()
    .required('This field is required'),

  q4: Yup.object()
    .nullable()
    .required('This field is required'),

  q5: Yup.object()
    .nullable()
    .when(['type'], (type, schema) => {
      if (type === TYPE.RECRUITER) {
        return schema;
      }
      return schema.required('This field is required');
    }),

  q6: Yup.object()
    .nullable()
    .when(['type'], (type, schema) => {
      if (type === TYPE.RECRUITER) {
        return schema;
      }
      return schema.required('This field is required');
    }),

  q7: Yup.object()
    .nullable()
    .when(['type'], (type, schema) => {
      if (type === TYPE.RECRUITER) {
        return schema;
      }
      return schema.required('This field is required');
    }),

  q8: Yup.object()
    .nullable()
    .when(['type'], (type, schema) => {
      if (type === TYPE.RECRUITER) {
        return schema;
      }
      return schema.required('This field is required');
    }),

  q9: Yup.object()
    .nullable()
    .when(['type'], (type, schema) => {
      if (type === TYPE.RECRUITER) {
        return schema;
      }
      return schema.required('This field is required');
    }),

  q10: Yup.object()
    .nullable()
    .when(['type'], (type, schema) => {
      if (type === TYPE.RECRUITER) {
        return schema;
      }
      return schema.required('This field is required');
    }),

  q11: Yup.object()
    .nullable()
    .when(['type'], (type, schema) => {
      if (type === TYPE.RECRUITER) {
        return schema;
      }
      return schema.required('This field is required');
    }),

  q12: Yup.object()
    .nullable()
    .when(['type'], (type, schema) => {
      if (type === TYPE.RECRUITER) {
        return schema;
      }
      return schema.required('This field is required');
    }),

  q13: Yup.object()
    .nullable()
    .when(['type'], (type, schema) => {
      if (type === TYPE.RECRUITER) {
        return schema;
      }
      return schema.required('This field is required');
    }),

  q14: Yup.object()
    .nullable()
    .when(['type'], (type, schema) => {
      if (type === TYPE.RECRUITER) {
        return schema;
      }
      return schema.required('This field is required');
    }),

  q15: Yup.object()
    .nullable()
    .required('This field is required'),

  q16: Yup.object()
    .nullable()
    .required('This field is required'),

  q41: Yup.object()
    .nullable()
    .when(['type'], (type, schema) => {
      if (type === TYPE.NON_RECRUITER) {
        return schema;
      }
      return schema.required('This field is required');
    }),

  q42: Yup.object()
    .nullable()
    .when(['type'], (type, schema) => {
      if (type === TYPE.NON_RECRUITER) {
        return schema;
      }
      return schema.required('This field is required');
    }),

  q43: Yup.object()
    .nullable()
    .when(['type'], (type, schema) => {
      if (type === TYPE.NON_RECRUITER) {
        return schema;
      }
      return schema.required('This field is required');
    }),

  q17: Yup.object()
    .nullable()
    .required('This field is required'),

  q18: Yup.number()
    .nullable()
    .when(['type'], (type, schema) => {
      if (type === TYPE.RECRUITER) {
        return schema;
      }
      return schema.required('This field is required');
    }),

  q29: Yup.string()
    .nullable()
    .max(15000, 'You have exceeded the maximum number of 15000 characters'),

  q30: Yup.string()
    .nullable()
    .max(15000, 'You have exceeded the maximum number of 15000 characters'),

  q31: Yup.string()
    .nullable()
    .max(15000, 'You have exceeded the maximum number of 15000 characters')
    .required('This field is required'),

  q32: Yup.string()
    .nullable()
    .max(15000, 'You have exceeded the maximum number of 15000 characters'),

  q44: Yup.string()
    .nullable()
    .max(15000, 'You have exceeded the maximum number of 15000 characters'),

  q33: Yup.number()
    .nullable()
    .when(['type'], (type, schema) => {
      if (type === TYPE.RECRUITER) {
        return schema;
      }
      return schema.required('This field is required');
    }),

  q34: Yup.number()
    .nullable()
    .when(['type'], (type, schema) => {
      if (type === TYPE.RECRUITER) {
        return schema;
      }
      return schema.required('This field is required');
    }),

  q35: Yup.number()
    .nullable()
    .when(['type'], (type, schema) => {
      if (type === TYPE.RECRUITER) {
        return schema;
      }
      return schema.required('This field is required');
    }),

  q36: Yup.object()
    .nullable()
    .when(['type'], (type, schema) => {
      if (type === TYPE.RECRUITER) {
        return schema;
      }
      return schema.required('This field is required');
    }),

  q37: Yup.number()
    .nullable()
    .when(['type'], (type, schema) => {
      if (type === TYPE.RECRUITER) {
        return schema;
      }
      return schema.required('This field is required');
    }),

  q38: Yup.string()
    .nullable()
    .max(15000, 'You have exceeded the maximum number of 15000 characters'),

  q39: Yup.string()
    .nullable()
    .when(['type'], (type, schema) => {
      if (type === TYPE.RECRUITER) {
        return schema;
      }
      return schema.required('This field is required');
    }),

  q40: Yup.object()
    .nullable()
    .when(['type', 'q39'], (type, q39, schema) => {
      if (type === TYPE.RECRUITER || (q39 && q39 === 'No')) {
        return schema;
      }
      return schema.required('This field is required');
    }),

  q45: Yup.array()
    .nullable()
    .when(['type'], (type, schema) => {
      if (type === TYPE.NON_RECRUITER) {
        return schema;
      }
      return schema.required('This field is required');
    }),

  email: Yup.string()
    .nullable()
    .max(100, 'You have exceeded the maximum number of 100 characters')
    .when(['isCandidate'], (isCandidate, schema) => {
      if (isCandidate) {
        return schema;
      }
      return schema.test(
        'required-email',
        'Email field is required',
        value => !!value
      );
    }),

  fullname: Yup.string()
    .nullable()
    .max(100, 'You have exceeded the maximum number of 100 characters')
    .when(['isCandidate'], (isCandidate, schema) => {
      if (isCandidate) {
        return schema;
      }
      return schema.test(
        'required-fullname',
        'Full Name field is required',
        value => !!value
      );
    }),

  phone: Yup.string()
    .nullable()
    .max(30, 'You have exceeded the maximum number of 30 characters')
    .when(['isCandidate'], (isCandidate, schema) => {
      if (isCandidate) {
        return schema;
      }
      return schema.test(
        'required-email',
        'Phone field is required',
        value => !!value
      );
    }),
});
